import { render, staticRenderFns } from "./ContactHealthRoom.vue?vue&type=template&id=74c57202"
import script from "./ContactHealthRoom.vue?vue&type=script&lang=js"
export * from "./ContactHealthRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports